import { ReactNode } from "react";
import { cn } from "@/core/helpers/cn";

type Props = {
  className?: string;
  children?: ReactNode | ReactNode[];
};

export default function TransportWarehouseInfoCard({ className, children }: Props) {
  return (
    <div
      className={cn("h-42 p-7.5 bg-dark-800/50 rounded-2xl flex flex-col items-start", className)}
    >
      {children}
    </div>
  );
}
